import { rem } from "polished";
import styled from "styled-components";

import InternalGallery from "@/components/editor/shared/sections/gallery/gallery-component";

const Gallery = styled(InternalGallery)`
  img {
    border-radius: ${rem(20)};
  }
`;

export default Gallery;
